<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<h4>Video Upload</h4>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				
				<container>
					<loading v-if="uploading"/>

					<template v-if="!uploaded && !uploading">
						<div class="cover-image" @click="$refs.video.click()">
							Upload
							<input type="file" ref="video" accept="video/*" @change="handleFile($event)" style="display: none" />
						</div>
					</template>

					<template v-if="uploaded">
						{{video_hash}}
					</template>
					
				</container>
				
				
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		created() {
		},
		data() {
			return {
				uploading: false,
				video_hash: "",
				uploaded: false
			}
		},
		methods: {
			handleFile(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.video.files[0]);
				this.uploading = true;
				this.$http.post(this.config.api + "/user/upload", formData).then(res => {
					this.uploading = false;
					if (res.body.status == 'success') {
						this.video_hash = res.body.data.hash;
						this.uploaded = true;
					}
				})
			},
		}
	}
</script>
<style>
.cover-image {
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard.vue